import { useEffect, useState } from 'react';
import {
  Modal, ModalDialog, ModalClose, Typography, Box, Button, Alert,
  CircularProgress, Avatar, Divider, Stack,
} from '@mui/joy';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

import { APIGetMisWidgetConfig } from '../../api';

// Небольшая модалка онлайн-записи.
// Сайт-виджет «АЛВИ» запрещает встраивание во фрейм (X-Frame-Options / CSP),
// поэтому не встраиваем его, а объясняем пользователю и открываем в новой вкладке.
// URL и флаг включения берём с сервера (/api/main/mis/widget-config/) — не хардкодим.
export default function BookingModal({ open, onClose, token }) {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setLoading(true); setError(''); setUrl('');
    APIGetMisWidgetConfig(token)
      .then((d) => {
        setUrl(d?.url || '');
        if (!d?.enabled || !d?.url) setError('Онлайн-запись временно недоступна. Попробуйте позже.');
      })
      .catch(() => setError('Не удалось загрузить форму записи. Попробуйте позже.'))
      .finally(() => setLoading(false));
  }, [open, token]);

  const proceed = () => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
    // Закрываем окно — при закрытии кабинет обновит «Мои записи».
    onClose?.();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog layout="center" sx={{ maxWidth: 440, width: '100%' }}>
        <ModalClose />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <Avatar variant="soft" color="primary" sx={{ '--Avatar-size': '40px' }}>
            <EventAvailableRoundedIcon />
          </Avatar>
          <Typography level="title-lg">Запись на приём</Typography>
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <>
            <Alert color="neutral" variant="soft" sx={{ mb: 2 }}>{error}</Alert>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="plain" color="neutral" onClick={onClose}>Закрыть</Button>
            </Box>
          </>
        ) : (
          <>
            <Typography level="body-md" sx={{ mb: 1 }}>
              Сейчас откроется сайт клиники «АЛВИ», где можно выбрать врача, удобные дату
              и время и записаться на приём онлайн.
            </Typography>
            <Typography level="body-sm" textColor="text.tertiary" sx={{ mb: 2 }}>
              После записи данные автоматически подтянутся в приложение — запись появится
              в разделе «Мои записи». Сайт откроется в новой вкладке.
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button variant="plain" color="neutral" onClick={onClose}>Отмена</Button>
              <Button color="primary" endDecorator={<OpenInNewRoundedIcon />} onClick={proceed}>
                Перейти
              </Button>
            </Stack>
          </>
        )}
      </ModalDialog>
    </Modal>
  );
}